const brands = [
  { name: 'InsureCo Group', icon: 'ri-shield-check-line' },
  { name: 'Apex Financial', icon: 'ri-bank-line' },
  { name: 'Urban Realty', icon: 'ri-building-2-line' },
  { name: 'PrimeServ Co.', icon: 'ri-tools-line' },
  { name: 'Meridian Advisory', icon: 'ri-briefcase-4-line' },
  { name: 'Clearpath Finance', icon: 'ri-line-chart-line' },
];

export default function TrustBar() {
  return (
    <section className="bg-white dark:bg-[#070D1B] border-y border-[#E5E7EB] dark:border-white/10">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-10">
        <p className="text-xs text-[#0B2A4A]/60 dark:text-white/45 tracking-widest uppercase text-center mb-8 font-medium">
          Trusted by growing teams across insurance, finance, real estate, and service industries
        </p>
        <div className="flex items-center justify-between gap-6 flex-wrap">
          {brands.map((brand) => (
            <div
              key={brand.name}
              className="flex items-center gap-2.5 text-[#0B2A4A]/55 hover:text-[#0B2A4A]/80 dark:text-white/45 dark:hover:text-white/70 transition-colors cursor-default"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${brand.icon} text-base`} />
              </div>
              <span className="text-sm font-medium tracking-wide whitespace-nowrap">
                {brand.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
